import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  IconButton,
  TextField,
  FormControl,
  Link,
  Dialog,
  DialogContent,
  Grid,
  Typography,
  // CircularProgress,
  Box,
  Tooltip,
} from "@material-ui/core";
import { Edit, Save, Cancel } from "@material-ui/icons";
import { appUrl } from "../../../../../../utils/config";
import axios from "axios";
import { useDispatch } from "react-redux";
import { downloadCustomUploadedFile } from "../../../../containers/actions/common/fileActions"; // 🔹 CHANGED CODE
import {
  DESTROY_BACKDROP,
  OPEN_BACKDROP,
} from "../../../../containers/actions/types";
// import jwt_decode from "jwt-decode";
import StyledButton from "../../models/Button";
import WarningIcon from "@material-ui/icons/Warning";
import CloseIcon from "@material-ui/icons/Close";
import AttachmentIcon from "@material-ui/icons/Attachment";
import SuccessFailedPopUp from "./SuccessFailedPopUp";
import moment from "moment";
import { convertToLocaleDateTime } from "../../functionalComponents/FormatDateTimeToLocale";
import SaveAltIcon from '@material-ui/icons/SaveAlt';

const commonCellStyle = { textAlign: "left", whiteSpace: "nowrap" };

const inputStyle = { width: "100%", minWidth: 100 };

const ProductDetailsTable = ({
  data,
  handleRefresh,
  featuresAccess,
  showPencilIcon,
}) => {
  const [row, setRow] = useState({
    ...data,
    scheduleLineDetails: {
      ...data.scheduleLineDetails,
      stabilityReqmtSamplingQtyOrFormNo: data?.scheduleLineDetails?.stabilityReqmtSamplingQtyOrFormNo ? data?.scheduleLineDetails?.stabilityReqmtSamplingQtyOrFormNo : data?.scheduleLineDetails?.stabilityReqmtSamplingQty ? String(data?.scheduleLineDetails?.stabilityReqmtSamplingQty) : null,
    },
    editMode: {
      EUImportationSamplingReqd: false,
      stabilityReqmtSampling: false,
      artworkRequired: false,
      EUImportationSamplingQty: false,
      // stabilityReqmtSamplingQty: false,
      stabilityReqmtSamplingQtyOrFormNo: false,
      artworkReferenceNumber: false,
      formNumberDocuments: false,
      artworkDocuments: false,
    },
  });
  const [documentsList, setDocumentsList] = useState([]);
  const [tempDocumentsList, setTempDocumentsList] = useState([]);
  const [editTemp, setEditTemp] = useState({});
  const [formFileSavedDialog, setFormFileSavedDialog] = useState({ success: false, failure: false, documentType: "formNumberDoc" })
  // const [savingField, setSavingField] = useState(null);
  const [saveFailed, setSaveFailed] = useState(false);
  const dispatch = useDispatch();
  // const [loading, setLoading] = useState(true);

  const { authToken } = localStorage;
  // var token = authToken;
  // var decoded = jwt_decode(token);

  // console.log("featuresAccess", featuresAccess);
  // const EUImportationSamplingQty=row?.scheduleLineDetails?.EUImportationSamplingQty,
  const responseData = {
    EUImportationSamplingQty:
      row?.scheduleLineDetails?.EUImportationSamplingQty,
    // stabilityReqmtSamplingQty:
    // row?.scheduleLineDetails?.stabilityReqmtSamplingQty,
    stabilityReqmtSamplingQtyOrFormNo: row?.scheduleLineDetails?.stabilityReqmtSamplingQtyOrFormNo ? row?.scheduleLineDetails?.stabilityReqmtSamplingQtyOrFormNo : row?.scheduleLineDetails?.stabilityReqmtSamplingQty ? String(row?.scheduleLineDetails?.stabilityReqmtSamplingQty) : null,
    artworkReferenceNumber: row?.scheduleLineDetails?.artworkReferenceNumber,
    productTypeName: row?.scheduleLineDetails?.productTypeName,
    market: row?.scheduleLineDetails?.market,
    brand: row?.scheduleLineDetails?.brand,
  };

  const featureAccessMap = {
    EUImportationSamplingReqd: "editEUImportationSampling",
    EUImportationSamplingQty: "editEUImportationSamplingQuantity",
    stabilityReqmtSampling: "editStabilityRequirementSampling",
    // stabilityReqmtSamplingQty: "editStabilityRequirementSamplingQuantity",
    stabilityReqmtSamplingQtyOrFormNo: "editStabilityRequirementSamplingQuantity",
    artworkRequired: "editArtworkRequired",
    artworkReferenceNumber: "editArtworkReferenceNumber",
    // Add others if needed
  };

  const toggleEditMode = (field) => {
    // console.log("field", field);
    setEditTemp({});
    setRow({ ...row, editMode: { ...row.editMode, [field]: true } });
  };

  const handleSave = async (field) => {
    // setSavingField(field);
    let updatedRow = { ...row, editMode: { ...row.editMode, [field]: false } };

    if (editTemp[field] !== undefined) {
      updatedRow[field] = editTemp[field];

      if (field === "EUImportationSamplingReqd") {
        updatedRow.EUImportationSamplingQty =
          editTemp[field] === "Yes"
            ? responseData.EUImportationSamplingQty
            : "NA";
      }

      if (field === "stabilityReqmtSampling") {
        // updatedRow.stabilityReqmtSamplingQty =
        //   editTemp[field] === "Yes"
        //     ? responseData.stabilityReqmtSamplingQty
        //     : "NA";
        updatedRow.stabilityReqmtSamplingQtyOrFormNo =
          editTemp[field] === "Yes"
            ? responseData.stabilityReqmtSamplingQtyOrFormNo
            : "NA";
      }

      if (field === "artworkRequired") {
        updatedRow.artworkReferenceNumber =
          editTemp[field] === "Yes"
            ? responseData.artworkReferenceNumber
            : "NA";
      }
    }

    if (editTemp[field] === "Yes") {
      updatedRow.editMode[`${field}Qty`] = true;
      updatedRow.editMode["artworkReferenceNumber"] =
        field === "artworkRequired";
    } else {
      updatedRow.editMode[`${field}Qty`] = false;
      updatedRow.editMode["artworkReferenceNumber"] = false;
    }

    setRow(updatedRow);
    setEditTemp({});
    // setSavingField(null);

    const requestObj = {
      schrockenSLID: row?.scheduleLineDetails?.schrockenSLID,
      vendorMosymphonyID: row?.scheduleLineDetails?.vendorMosymphonyID,
      brandOwnerMosymphonyID: row?.scheduleLineDetails?.brandOwnerMosymphonyID,
    };

    // 🔹 **Conditionally apply `true/false` only for dropdown fields**
    if (
      [
        "EUImportationSamplingReqd",
        "stabilityReqmtSampling",
        "artworkRequired",
      ].includes(field)
    ) {
 requestObj[field] = updatedRow[field] === "Yes" ? true : updatedRow[field] === "No" ? false : "none";
    } else {
      requestObj[field] = updatedRow[field]; // 🔹 **Text fields send user input as is**
    }

    if([
        "stabilityReqmtSamplingQtyOrFormNo",
      ].includes(field)){
      requestObj['stabilityReqQtyOrFormNoChanged'] = row?.scheduleLineDetails?.stabilityReqmtSamplingQtyOrFormNo &&  row?.scheduleLineDetails?.stabilityReqmtSamplingQtyOrFormNo !== updatedRow[field] ? true : false;
    }

    if (field === "stabilityReqmtSampling") {
      const prior = row?.scheduleLineDetails?.stabilityReqmtSampling;
      const incoming = updatedRow[field] === "Yes" ? true : updatedRow[field] === "No" ? false : "none";
      requestObj['stabilityReqmtSamplingChanged'] = (prior !== null && prior !== undefined && prior !== incoming) ? true : false;
    }

    if (field === "EUImportationSamplingReqd") {
      const prior = row?.scheduleLineDetails?.EUImportationSamplingReqd;
      const incoming = updatedRow[field] === "Yes" ? true : updatedRow[field] === "No" ? false : "none";
      requestObj['EUImportationSamplingReqdChanged'] = (prior !== null && prior !== undefined && prior !== incoming) ? true : false;
    }

    if (field === "EUImportationSamplingQty") {
      const prior = row?.scheduleLineDetails?.EUImportationSamplingQty;
      requestObj['EUImportationSamplingQtyChanged'] = (prior && prior !== updatedRow[field]) ? true : false;
    }

    if (field === "artworkReferenceNumber") {
      const prior = row?.scheduleLineDetails?.artworkReferenceNumber;
      requestObj['artworkReferenceNumberChanged'] = (prior && prior !== updatedRow[field]) ? true : false;
    }

    if (field === "artworkRequired") {
      const prior = row?.scheduleLineDetails?.artworkRequired;
      const incoming = updatedRow[field] === "Yes" ? true : updatedRow[field] === "No" ? false : "none";
      requestObj['artworkRequiredChanged'] = (prior !== null && prior !== undefined && prior !== incoming) ? true : false;
    }

    // try {
    //   // dispatch({
    //   //   type: OPEN_BACKDROP,
    //   // });
    //   await axios.post(
    //     `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateSLForPOMgmt`,
    //     requestObj
    //   );
    //   console.log("Data updated successfully:", requestObj);
    // } catch (error) {
    //   // dispatch({
    //   //   type: DESTROY_BACKDROP,
    //   // });
    //   console.error("Error updating data:", error);
    // }
    dispatch({
      type: OPEN_BACKDROP,
    });
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateSLForPOMgmt`,
        requestObj,
      )
      .then((res) => {
        if (res.data?.data?.status) {
          handleRefresh("updatedProductDetails");
          dispatch({
            type: DESTROY_BACKDROP,
          });
        } else {
          setSaveFailed(true);
          dispatch({
            type: DESTROY_BACKDROP,
          });
        }
      })
      .catch((err) => {
        setSaveFailed(true);
        dispatch({
          type: DESTROY_BACKDROP,
        });
        // console.log(err);
      });
  };

  const handleCancel = (field) => {
    setEditTemp({});
    setRow({ ...row, editMode: { ...row.editMode, [field]: false } });
  };

  useEffect(() => {
    const schrockenSLID = data?.scheduleLineDetails?.schrockenSLID;

    // if (!schrockenSLID) {
    //   setLoading(false);
    //   return;
    // }

    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllFilesForSL/${schrockenSLID}`,
      )
      .then((res) => {
        if (res.data.status && res.data.data) {
          setDocumentsList(res.data.data.customFiles || []);
          // setDocumentsList([
          //   {
          //     customFileType: "formNumberDoc",
          //     customFileName: "Patheon Toronto Documents 5110 2233444.pdf",
          //     schrockenCustomFileID: "SCF-001",
          //     schrockenSLID: 12345,
          //     schrockenBatchID: "SB-10025",
          //     lastUpdatedDate: "2026-01-24T07:09:17.477766497",
          //   }
          // ]
          // )
        }
      })
      .catch((err) => {
        // console.log("Error fetching documents:", err);
      })
      .finally(() => {
        // setLoading(false); // 🔹 Stop loading after API call (success or failure)
      });
    // setRow({ ...row, ...data });
  }, [data?.scheduleLineDetails?.schrockenSLID]); // Only call when schrockenSLID changes

  const handleFileClick = (fileID) => {
    const requestData = { schrockenCustomFileID: fileID };
    dispatch(downloadCustomUploadedFile(requestData));
  };

  // Helper function to determine if save should be disabled
  const isSaveDisabled = (field) => {
    const currentValue = editTemp[field];
    const isValueEmpty =
      currentValue === undefined ||
      currentValue === "" ||
      currentValue === null;

    // For dropdown fields, disable save if no option is selected
    if (
      [
        "EUImportationSamplingReqd",
        "stabilityReqmtSampling",
        "artworkRequired",
      ].includes(field)
    ) {
      return currentValue === undefined;
    }

    // For sampling quantity field, check if empty or invalid
    if (field === "EUImportationSamplingQty") {
      if (isValueEmpty) return true;

      const numericValue = parseFloat(currentValue);

      return isNaN(numericValue) || numericValue <= 0;
    }

    if (field === "stabilityReqmtSamplingQtyOrFormNo") {
      return isValueEmpty;
    }

    // For artworkReferenceNumber, allow empty but disable if undefined
    if (field === "artworkReferenceNumber") {
      return currentValue === undefined;
    }

    return false;
  };

  // const getCurrentDate = () => {
  //   const today = new Date();
  //   return today.toISOString().split("T")[0]; // Returns YYYY-MM-DD
  // };
  // console.log("Row", row);
  // // 🔹 Set the current date
  // const currentDate = getCurrentDate();

  const isEditable =
    [22, 23, 25, 29, 31, 30].includes(row?.scheduleLineDetails?.scheduleLineStatusID) &&
    (!row?.batchDetails?.batchStatusID ||
      row?.batchDetails?.batchStatusID === 1) &&
    (!row?.scheduleLineDetails?.deliveryDate ||
      moment().isSameOrBefore(
        moment(row.scheduleLineDetails.deliveryDate).subtract(1, "day"),
        "day"
      ));
  // &&
  // currentDate >= row?.batchDetails?.manufacturingStartDate - 7 &&
  // currentDate < row?.batchDetails?.manufacturingStartDate;

  // EUImportationSamplingQty and stabilityReqmtSamplingQtyOrFormNo stay editable from
  // "Shared with CMO" through the rest of the schedule line lifecycle, until 1 day before delivery.
  const isSamplingQtyEditable =
    [22, 23, 25, 29, 31, 30].includes(
      row?.scheduleLineDetails?.scheduleLineStatusID
    ) &&
    (!row?.scheduleLineDetails?.deliveryDate ||
      moment().isSameOrBefore(
        moment(row.scheduleLineDetails.deliveryDate).subtract(1, "day"),
        "day"
      ));

  const renderEditableDropdown = (field) => {
    return (
      <TableCell style={commonCellStyle}>
        {localStorage.collabType !== "CMO" ? (
          //&& row?.scheduleLineDetails?.plannerEmailID === decoded.email_address
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {isEditable ? ( // ✅ Only show dropdown when `isEditable` is true
              <FormControl variant="outlined" size="small" style={inputStyle}>
                <Select
                  value={
                    editTemp[field] !== undefined
                      ? editTemp[field]
                      : row?.scheduleLineDetails[field] === true
                        ? "Yes"
                        : row?.scheduleLineDetails[field] === false
                          ? "No"
                          : "none"
                  }
                  onChange={(e) =>
                    setEditTemp({ ...editTemp, [field]: e.target.value })
                  }
                  displayEmpty
                  disabled={!row.editMode[field]} // ✅ Dropdown only editable after clicking pencil icon
                >
                  <MenuItem value="none">
                    Select from list
                  </MenuItem>
                  <MenuItem value="Yes">
                    Yes {field === "artworkRequired" && " (New) "}{" "}
                  </MenuItem>
                  <MenuItem value="No">
                    No {field === "artworkRequired" && " (Current) "}
                  </MenuItem>
                </Select>
              </FormControl>
            ) : (
              // ✅ Show text if not editable
              <Typography variant="body2">
                {row?.scheduleLineDetails[field] === true
                  ? "Yes"
                  : row?.scheduleLineDetails[field] === false
                    ? "No"
                    : ""}
              </Typography>
            )}

            {isEditable &&
              localStorage.collabType !== "CMO" && // Ensure edit icons appear only when `isEditable`
              (row.editMode[field] ?
                (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSave(field)}
                      disabled={isSaveDisabled(field)}
                      style={{
                        opacity: isSaveDisabled(field) ? 0.5 : 1,
                      }}
                    >
                      <Save fontSize="small" />
                    </IconButton>
                    <IconButton size="small" onClick={() => handleCancel(field)}>
                      <Cancel fontSize="small" />
                    </IconButton>
                  </div>
                ) : (
                  featuresAccess?.[featureAccessMap[field]] &&
                  showPencilIcon && (
                    <IconButton
                      size="small"
                      onClick={() => toggleEditMode(field)}
                    >
                      <Edit fontSize="large" style={{ color: "#ec6535" }} />
                    </IconButton>
                  )
                ))}
          </div>
        ) : (
          <Typography variant="body2">
            {row?.scheduleLineDetails[field] === true
              ? "Yes"
              : row?.scheduleLineDetails[field] === false
                ? "No"
                : ""}
          </Typography>
        )}
      </TableCell>
    );
  };

  const renderEditableTextField = (field, conditionField) => {
    // const isDropdownYes = row[conditionField] === "Yes";
    // For artworkReferenceNumber, only pass when artworkRequired has a value (Yes or No)
    // For other fields, only pass when conditionField is true
    const isDropdownYes =
      field === "artworkReferenceNumber"
        ? (row?.scheduleLineDetails[conditionField] === true || row?.scheduleLineDetails[conditionField] === false) 
        : row?.scheduleLineDetails[conditionField] === true
          ? row?.scheduleLineDetails[conditionField]
          : false;
    const fieldIsEditable = [
      "EUImportationSamplingQty",
      "stabilityReqmtSamplingQtyOrFormNo",
      "artworkReferenceNumber"
    ].includes(field)
      ? isSamplingQtyEditable
      : isEditable;
    return (
      <TableCell style={commonCellStyle}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {localStorage.collabType !== "CMO" ? (
            // &&row?.scheduleLineDetails?.plannerEmailID === decoded.email_address
            // 🔹 Check if user is NOT CMO
            isDropdownYes && isEditable && fieldIsEditable ? (
              row.editMode[field] ? ( 
                <>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <TextField
                      variant="outlined"
                      size="small"
                      value={
                        editTemp[field] !== undefined
                          ? editTemp[field]
                          : row?.scheduleLineDetails[field] || ""
                      }
                      onChange={(e) => {
                        const value = e.target.value;
                        if (field === "artworkReferenceNumber") {
                          if (/^[a-zA-Z0-9-]*$/.test(e.target.value)) {
                            // ✅ Allow only letters & numbers
                            setEditTemp({
                              ...editTemp,
                              [field]: e.target.value,
                            });
                          }
                        } else if (
                          field === "EUImportationSamplingQty"
                          // || field === "stabilityReqmtSamplingQty"
                        ) {
                          if (
                            value === "" ||
                            (/^\d*\.?\d*$/.test(value) &&
                              (value === "" || parseFloat(value) > 0))
                          ) {
                            setEditTemp({ ...editTemp, [field]: value });
                          }
                        }
                        else if (
                          field === "stabilityReqmtSamplingQtyOrFormNo"
                        ) {
                          setEditTemp({ ...editTemp, [field]: value });
                        } else {
                          if (/^\d*$/.test(e.target.value)) {
                            // ✅ Only numbers for other fields
                            setEditTemp({
                              ...editTemp,
                              [field]: e.target.value,
                            });
                          }
                        }
                      }}
                      style={inputStyle}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSave(field)}
                      disabled={isSaveDisabled(field)}
                      style={{
                        opacity: isSaveDisabled(field) ? 0.5 : 1,
                      }}
                    >
                      <Save fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleCancel(field)}
                    >
                      <Cancel fontSize="small" />
                    </IconButton>
                  </div>
                </>
              ) : (
                // 🔹 Show value and pencil icon before entering edit mode
                <>
                  <span>{row?.scheduleLineDetails[field] || ""}</span>
                  {featuresAccess?.[featureAccessMap[field]] &&
                    showPencilIcon && (
                      <IconButton
                        size="small"
                        onClick={() => toggleEditMode(field)}
                      >
                        <Edit fontSize="large" style={{ color: "#ec6535" }} />{" "}
                        {/* 🔹 Added: Pencil icon */}
                      </IconButton>
                    )}
                </>
              )
            ) : (
              // 🔹 If not editable, just show the value
              !(["stabilityReqmtSamplingQtyOrFormNo"].includes(field) && row?.scheduleLineDetails[conditionField] === false) && <span>{row?.scheduleLineDetails[field] || ""}</span>
            )
          ) : (
            !(["stabilityReqmtSamplingQtyOrFormNo"].includes(field) && row?.scheduleLineDetails[conditionField] === false) && 
            <Typography variant="body2">
              {row?.scheduleLineDetails[field] || ""}
            </Typography> // 🔹 If CMO, show value in Typography
          )}
        </div>
      </TableCell>
    );
  };

  const handleFileUpload = (event) => {
    const files = Array.from(event.target.files);
    if (files.length > 0) {
      setTempDocumentsList(files);
    }
  };

  const handlefileSavedDefault = () => {
    setFormFileSavedDialog({ failure: false, success: false, documentType: "formNumberDoc" })
    handleRefresh("updatedProductDetails");
  }
  const handleSaveFiles = async (field) => {
    // const formData = new FormData();
    // formData.append("files", tempDocumentsList);
    // let files = []
    // tempDocumentsList.forEach((file) => {
    //   const reader = new FileReader();
    //   reader.readAsDataURL(file);
    //   reader.onabort = () => console.log('file reading was aborted');
    //   reader.onerror = () => console.log('file reading has failed');
    //   reader.onload = () => {
    //     let fileObject = {
    //       name: file.name,
    //       data: reader.result,
    //       customFileType: 'formNumberDoc',
    //     }
    //     files.push(fileObject)

    //   }
    // });
    // Decide the customFileType based on which field is being saved
    const customFileType =
      field === "artworkDocuments" ? "artworkDoc" : "formNumberDoc";

    const files = await Promise.all(
      tempDocumentsList.map((file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();

          reader.onload = () => {
            resolve({
              name: file.name,
              data: reader.result,
              customFileType,
            });
          };

          reader.onerror = reject;
          reader.onabort = reject;

          reader.readAsDataURL(file);
        });
      })
    );

    let reqObj = {
      files: files,
      // fileType: 'formNumberDoc',
      schrockenSLID: row?.scheduleLineDetails?.schrockenSLID,
      vendorMosymphonyID: row?.scheduleLineDetails?.vendorMosymphonyID,
      brandOwnerMosymphonyID: row?.scheduleLineDetails?.brandOwnerMosymphonyID,
      poNumber: row?.scheduleLineDetails?.scheduleAgreementNumber
    }

    // dispatch({
    //   type: OPEN_BACKDROP,
    // });
    // setTimeout(() => {
    //   setFormFileSavedDialog((prev) => ({ ...prev, success: true }))
    //   //  setFormFileSavedDialog((prev)=> ({...prev,failure: true}))
    //   dispatch({
    //     type: DESTROY_BACKDROP,
    //   });
    //   handleRefresh("updatedProductDetails");
    // }, 1000);
    dispatch({
      type: OPEN_BACKDROP,
    });
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/uploadCustomPODocuments`, reqObj
      )
      .then((res) => {
        if (res.data?.status) {

          dispatch({
            type: DESTROY_BACKDROP,
          });
          setFormFileSavedDialog((prev) => ({ ...prev, success: true, documentType: customFileType === "artworkDoc" ? "artworkDoc" : "formNumberDoc" }))
        } else {
          setFormFileSavedDialog((prev) => ({ ...prev, failure: true, documentType: customFileType === "artworkDoc" ? "artworkDoc" : "formNumberDoc" }))
          dispatch({
            type: DESTROY_BACKDROP,
          });
        }
      })
      .catch((err) => {
        setFormFileSavedDialog((prev) => ({ ...prev, failure: true }))
        dispatch({
          type: DESTROY_BACKDROP,
        });
      });
  }

  const renderFileUploadField = (field, conditionField) => {
    const isDropdownYes =
      row?.scheduleLineDetails[conditionField] === true
        ? row?.scheduleLineDetails[conditionField]
        : false;

    const files = () => {
      if (
        documentsList.filter((file) => file.customFileType === "formNumberDoc")
          .length === 0
      ) {
        return <Typography variant="body2"></Typography>;
      }
      return <div style={{ display: 'flex', gap: '2px', flexDirection: 'column' }}>
        {documentsList
          .filter((file) => file.customFileType === "formNumberDoc")
          .map((file) => (
            <div key={file.schrockenCustomFileID}>
              <div style={{ display: 'flex', gap: '2px' }}>
                <SaveAltIcon fontSize="small" style={{ color: '#1976d2' }} />
                <Link
                  component="button"
                  title={file.customFileName}
                  style={{
                    maxWidth: "200px",
                    color: "#1976d2",
                    cursor: "pointer",
                    textDecoration: "underline",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "inline-block",
                    padding: 0,
                    border: "none",
                    background: "none",
                    textAlign: "left",
                  }}
                  onClick={() => handleFileClick(file.schrockenCustomFileID)}
                >
                  {file.customFileName}
                </Link>
              </div>


              {file.lastUpdatedDate && (
                <Typography
                  style={{
                    fontSize: "12px",
                    marginTop: "2px",
                    color: "#6b7280",
                  }}
                >
                  Uploaded @{" "}
                  {moment(convertToLocaleDateTime(file.lastUpdatedDate))
                    .format("DD-MMM-YYYY HH:mm:ss")
                    .toUpperCase()}
                </Typography>
              )}
            </div>
          ))}
      </div>
    }
    return (
      <TableCell style={commonCellStyle}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            justifyContent: "space-between",
          }}
        >
          {localStorage.collabType !== "CMO" ? (
            isDropdownYes && isEditable ? (
              row.editMode[field] ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    {tempDocumentsList.map((val, index1) => (
                      <Box
                        key={index1}
                        display="flex"
                        alignItems="center"
                        mb={1}
                      >
                        {/* Tooltip shows full name */}
                        <Tooltip title={val.name} arrow>
                          <Typography
                            style={{
                              maxWidth: "200px", // adjust as needed
                              fontSize: "20px",
                              color: "#34a0f7",
                              textDecoration: "underline",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              cursor: "pointer",
                            }}
                          >
                            {val.name}
                          </Typography>
                        </Tooltip>

                        <IconButton
                          size="small"
                          onClick={() => {
                            setTempDocumentsList(
                              tempDocumentsList.filter(
                                (file, index2) =>
                                  !(
                                    file.name === val.name && index1 === index2
                                  )
                              )
                            )
                            if (tempDocumentsList.filter(
                              (file, index2) =>
                                !(
                                  file.name === val.name && index1 === index2
                                ),
                            ).length === 0) {
                              handleCancel(field);
                            }

                          }
                          }
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    ))}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "3px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSaveFiles(field)}
                      disabled={tempDocumentsList.length === 0}
                      style={{
                        opacity: tempDocumentsList.length === 0 ? 0.5 : 1,
                      }}
                    >
                      <Save fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => {
                        setTempDocumentsList([]);
                        handleCancel(field);
                      }}
                    >
                      <Cancel fontSize="small" />
                    </IconButton>
                  </div>
                </>
              ) : (
                <>
                  {files()}
                  {featuresAccess?.editStabilityRequirementSamplingQuantity &&
                    showPencilIcon && (
                      <IconButton color="primary" component="label">
                        <AttachmentIcon style={{ color: "black" }} />
                        <input
                          type="file"
                          hidden
                          multiple
                          onChange={(e) => {
                            handleFileUpload(e);
                            toggleEditMode(field);
                          }}
                          accept=".csv,.xls,.xlsx,.pdf,.jpeg,.png,.jpg,.bmp,.doc,.docx"
                        />
                      </IconButton>
                    )}
                </>
              )
            ) : (
              !(row?.scheduleLineDetails[conditionField] === false) && files()
            )
          ) : (
            !(row?.scheduleLineDetails[conditionField] === false) && files()
          )}
        </div>
      </TableCell>
    );
  };

  // Artwork Document upload / download – mirrors Form Number Document logic
  const renderArtworkFileUploadField = (field, conditionField) => {
    // Artwork Document can be uploaded regardless of the Artwork Required selection (Yes, No, or Select from list)
    const isDropdownYes =
      field === "artworkDocuments"
        ? true
        : row?.scheduleLineDetails[conditionField] === true
          ? row?.scheduleLineDetails[conditionField]
          : false;

    const files = () => {
      const artworkFiles = documentsList.filter(
        (file) => file.customFileType === "artworkDoc",
      );

      if (artworkFiles.length === 0) {
        return <Typography variant="body2"></Typography>;
      }

      return (
        <div style={{ display: "flex", gap: "2px", flexDirection: "column" }}>
          {artworkFiles.map((file) => (
            <div key={file.schrockenCustomFileID}>
              <div style={{ display: "flex", gap: "2px" }}>
                <SaveAltIcon fontSize="small" style={{ color: "#1976d2" }} />
                <Link
                  component="button"
                  title={file.customFileName}
                  style={{
                    maxWidth: "200px",
                    color: "#1976d2",
                    cursor: "pointer",
                    textDecoration: "underline",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "inline-block",
                    padding: 0,
                    border: "none",
                    background: "none",
                    textAlign: "left",
                  }}
                  onClick={() => handleFileClick(file.schrockenCustomFileID)}
                >
                  {file.customFileName}
                </Link>
              </div>

              {file.lastUpdatedDate && (
                <Typography
                  style={{
                    fontSize: "12px",
                    marginTop: "2px",
                    color: "#6b7280",
                  }}
                >
                  Uploaded @{" "}
                  {moment(convertToLocaleDateTime(file.lastUpdatedDate))
                    .format("DD-MMM-YYYY HH:mm:ss")
                    .toUpperCase()}
                </Typography>
              )}
            </div>
          ))}
        </div>
      );
    };

    return (
      <TableCell style={commonCellStyle}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            justifyContent: "space-between",
          }}
        >
          {localStorage.collabType !== "CMO" ? (
            isDropdownYes && isEditable ? (
              row.editMode[field] ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    {tempDocumentsList.map((val, index1) => (
                      <Box
                        key={index1}
                        display="flex"
                        alignItems="center"
                        mb={1}
                      >
                        <Tooltip title={val.name} arrow>
                          <Typography
                            style={{
                              maxWidth: "200px",
                              fontSize: "20px",
                              color: "#34a0f7",
                              textDecoration: "underline",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              cursor: "pointer",
                            }}
                          >
                            {val.name}
                          </Typography>
                        </Tooltip>

                        <IconButton
                          size="small"
                          onClick={() => {
                            setTempDocumentsList(
                              tempDocumentsList.filter(
                                (file, index2) =>
                                  !(
                                    file.name === val.name &&
                                    index1 === index2
                                  ),
                              ),
                            );
                            if (
                              tempDocumentsList.filter(
                                (file, index2) =>
                                  !(
                                    file.name === val.name &&
                                    index1 === index2
                                  ),
                              ).length === 0
                            ) {
                              handleCancel(field);
                            }
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    ))}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "3px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSaveFiles(field)}
                      disabled={tempDocumentsList.length === 0}
                      style={{
                        opacity: tempDocumentsList.length === 0 ? 0.5 : 1,
                      }}
                    >
                      <Save fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => {
                        setTempDocumentsList([]);
                        handleCancel(field);
                      }}
                    >
                      <Cancel fontSize="small" />
                    </IconButton>
                  </div>
                </>
              ) : (
                <>
                  {files()}
                  {featuresAccess?.editArtworkReferenceNumber &&
                    showPencilIcon && (
                    <IconButton color="primary" component="label">
                      <AttachmentIcon style={{ color: "black" }} />
                      <input
                        type="file"
                        hidden
                        multiple
                        onChange={(e) => {
                          handleFileUpload(e);
                          toggleEditMode(field);
                        }}
                        accept=".csv,.xls,.xlsx,.pdf,.jpeg,.png,.jpg,.bmp,.doc,.docx"
                      />
                    </IconButton>
                  )}
                </>
              )
            ) : (
              files()
            )
          ) : (
            files()
          )}
        </div>
      </TableCell>
    );
  };

  return (
    <React.Fragment>
      <TableContainer component={Paper}>
        <Table className="default-table-styles">
          <TableHead>
            <TableRow style={{ backgroundColor: "#eee" }}>
              <TableCell
                style={{
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  padding: "12px 16px", // Added consistent padding
                  backgroundColor: "#eee",
                }}
              >
                Product Type
              </TableCell>
              <TableCell
                style={{
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  padding: "12px 16px", // Added consistent padding
                  backgroundColor: "#eee",
                }}
              >
                Brand
              </TableCell>
              <TableCell
                style={{
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  padding: "12px 16px", // Added consistent padding
                  backgroundColor: "#eee",
                }}
              >
                Market Order
              </TableCell>
              <TableCell
                style={{
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  padding: "12px 16px", // Added consistent padding
                  backgroundColor: "#eee",
                }}
              >
                EU Importation Sampling
              </TableCell>
              <TableCell
                style={{
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  padding: "12px 16px", // Added consistent padding
                  backgroundColor: "#eee",
                }}
              >
                EU Importation Sampling Qty.
              </TableCell>
              <TableCell
                style={{
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  padding: "12px 16px", // Added consistent padding
                  backgroundColor: "#eee",
                }}
              >
                Stability Req. Sampling
              </TableCell>
              <TableCell
                style={{
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  padding: "12px 16px", // Added consistent padding
                  backgroundColor: "#eee",
                }}
              >
                Stability Req. Sampling Qty. /
                <br />
                Form Number
              </TableCell>
              <TableCell
                style={{
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  padding: "12px 16px", // Added consistent padding
                  backgroundColor: "#eee",
                }}
              >
                Form Number Document
              </TableCell>
              <TableCell
                style={{
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  padding: "12px 16px", // Added consistent padding
                  backgroundColor: "#eee",
                }}
              >
                Artwork Required
              </TableCell>
              <TableCell
                style={{
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  padding: "12px 16px", // Added consistent padding
                  backgroundColor: "#eee",
                }}
              >
                Artwork Reference Number
              </TableCell>
              <TableCell
                style={{
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  padding: "12px 16px",
                  backgroundColor: "#eee",
                }}
              >
                Artwork Document
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell>{responseData.productTypeName || ""}</TableCell>
              <TableCell>{responseData.brand || ""}</TableCell>
              <TableCell>{responseData.market || ""}</TableCell>

              {renderEditableDropdown("EUImportationSamplingReqd")}
              {renderEditableTextField(
                "EUImportationSamplingQty",
                "EUImportationSamplingReqd",
              )}
              {renderEditableDropdown("stabilityReqmtSampling")}
              {/* {renderEditableTextField(
                "stabilityReqmtSamplingQty",
                "stabilityReqmtSampling",
              )} */}
              {renderEditableTextField(
                "stabilityReqmtSamplingQtyOrFormNo",
                "stabilityReqmtSampling",
              )}
              {renderFileUploadField(
                "formNumberDocuments",
                "stabilityReqmtSampling",
              )}
              {renderEditableDropdown("artworkRequired")}
              {renderEditableTextField(
                "artworkReferenceNumber",
                "artworkRequired",
              )}

              {renderArtworkFileUploadField(
                "artworkDocuments",
                "artworkRequired",
              )}

              {/* <TableCell>{row.artworkDocuments || "NA"}</TableCell> */}

              {/* <TableCell>
  {loading ? ( // 🔹 Show spinner while loading
    <CircularProgress size={24} />
  ) : (() => {
    const file = documentsList.find(
      (file) => file.customFileType === "artworkDoc"
    );
    if (file) {
      return featuresAccess?.downloadArtworkRequired ? (
        <Link
          style={{
            color: "blue",
            cursor: "pointer",
            textDecoration: "underline",
          }}
          onClick={() => handleFileClick(file.schrockenCustomFileID)}
        >
          {file.customFileName}
        </Link>
      ) : (
        <span style={{ color: "gray", cursor: "not-allowed" }}>
          {file.customFileName}
        </span>
      );
    } else {
      return "NA";
    }
  })()}
</TableCell> */}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog
        open={saveFailed}
        onClose={() => {
          setSaveFailed(false);
        }}
        fullWidth
      >
        <DialogContent style={{ padding: "2rem" }}>
          <Grid container justifyContent="flex-end">
            <Typography
              variant="body2"
              style={{
                fontSize: "1rem",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                setSaveFailed(false);
              }}
            >
              Close <CloseIcon fontSize="large" />
            </Typography>
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <WarningIcon
                style={{
                  fontSize: "5rem",
                  color: "#F00",
                }}
              />
            </Grid>
          </Grid>
          <div
            style={{
              display: "flex",
              justifyContent: "center", // Horizontally center the CircularProgress
              alignItems: "center", // Vertically center the CircularProgress
              height: "80px", // Optional: Set a height to vertically center the loader
              border: "2px solid #FF0000",
              backgroundColor: "#FFF0F0",
              // width: "100%",
            }}
          >
            <Typography style={{ textAlign: "center" }}>
              Something went wrong. Please try again.
            </Typography>
          </div>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              padding: "0.5rem",
            }}
          >
            <StyledButton
              style={{ paddingLeft: "3rem", paddingRight: "3rem" }}
              onClick={() => {
                setSaveFailed(false);
              }}
            >
              Ok
            </StyledButton>
          </Grid>
        </DialogContent>
      </Dialog>
      <SuccessFailedPopUp formFileSavedDialog={formFileSavedDialog} handlefileSavedDefault={handlefileSavedDefault} />
    </React.Fragment>
  );
};

export default ProductDetailsTable;
